module.exports = __webpack_public_path__ + "img/Oiltanking_South-America_Peru_Callao_old.5db5ffe7.jpg";